import { uniqBy } from 'lodash'
import { InterventionInfo } from 'components/Assessments/hooks/constants'
import { BASE_API_URL } from 'utils/constants'
import { HttpClient } from 'utils/httpClient'
import { Equipment, RawDiagnosesData } from './types'

export async function getInterventionsInfo(): Promise<InterventionInfo[]> {
  const response = await new HttpClient().fetch(`${BASE_API_URL}/static/interventions_info`)
  if (!response.ok) {
    throw new Error(`Error fetching interventions: ${response.status}`)
  }
  const res = await response.json()
  const interventionsInfo = res.data as InterventionInfo[]

  return uniqBy(interventionsInfo, 'task').sort((a: InterventionInfo, b: InterventionInfo) => {
    if (a.task && b.task && a.task < b.task) {
      return -1
    }
    if (a.task && b.task && a.task > b.task) {
      return 1
    }
    return 0
  })
}

export async function getEquipments(): Promise<Equipment[]> {
  const response = await new HttpClient().fetch(`${BASE_API_URL}/static/equipment`)
  if (!response.ok) {
    throw new Error(`Error fetching equipment: ${response.status}`)
  }
  const res = await response.json()
  return res.data as Equipment[]
}

export async function fetchDiagnosis(searchTerm: string): Promise<RawDiagnosesData[]> {
  const params = new URLSearchParams()
  params.set('search_string', searchTerm)
  const response = await new HttpClient().fetch(
    `${BASE_API_URL}/static/diagnoses?${params.toString()}`
  )
  if (!response.ok) {
    throw new Error(`Error fetching diagnosis: ${response.status}`)
  }
  const res = await response.json()
  return res.data as RawDiagnosesData[]
}
